<template>
  <!-- <v-card
    :elevation="0"
    :style="{ 'max-width': isSimulation ? '380px' : '100%'}"
  > -->
  <v-card
    :elevation="0"
    style="background: transparent !important;"
    :style="{ 'width': isSimulation ? '375px' : `${sizeW}px !important`}"
  >
    <v-carousel 
      v-if="data.GallerySlider" 
      hide-delimiters
      :height="carouselHeight"
    >
      <v-carousel-item
        v-for="(item,i) in data.Images"
        :key="i"
        :src="item"
      />
    </v-carousel>
    <v-container v-else grid-list-sm fluid>
      <v-layout
        wrap
        :style="{
          'margin': !isSimulation && isDesktop ? '10px 20px 10px 20px' : '5px' 
        }"
      >
        <v-flex
          v-for="image in data.Images"
          :key="image"
          v-bind="{ [`xs${!isSimulation && isDesktop && data.Images.length >= 4 ? 3 : 4}`]: true }"
          d-flex
          child-flex
        >
          <v-card flat tile class="d-flex" style="background: transparent !important;">
            <v-img
              :src="image"
              :lazy-src="image"
              aspect-ratio="1"
              class="grey lighten-2"
              @click="handleOpenImage(image)"
            >
              <template v-slot:placeholder>
                <v-layout
                  fill-height
                  align-center
                  justify-center
                  ma-0
                >
                  <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
                </v-layout>
              </template>
            </v-img>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
    <v-overlay :value="overlay">
      <v-btn
        icon
        :z-index="6"
        @click="overlay = false"
      >
        <v-icon>mdi-close</v-icon>
      </v-btn>
      <v-img
        :z-index="5"
        :src="selectImage"
        :lazy-src="selectImage"
        aspect-ratio="1.7"
        class="grey lighten-2"
        min-width="calc(80vw)"
        max-width="calc(100vw)"
        @click="handleOpenImage(null)"
      />
    </v-overlay>
  </v-card>
</template>

<script>
  import {
    mapState
  } from 'vuex'
  import utils from '@/services/utils'
  import constants from '@/constants'
  export default {
    props: {
      data: {
        type: Object,
        required: true,
        default: null
      },
    },
    data: () => ({
      overlay: false,
      selectImage: null
    }),
    computed: {
      ...mapState('app',['locale', 'FontContent', 'FontSizeContent', 'ColorContent']),
      isSimulation () {
        return constants.simulationsRutes.indexOf(this.$route.path.split('/')[1]) >= 0
      },
      isDesktop () {
        return !utils.isMobile()
      },
      text () {
        return this.data.Text ? utils.getTranslation (this.data.Text, this.locale) : ''
      },
      sizeW () {
        return window.innerWidth - (!utils.isMobile() ? 360 : 0)
      },
      carouselHeight () {
        if (this.isDesktop && !this.isSimulation) return 500
        return this.data.GalleryMobileHeight && this.data.GalleryMobileHeight.length > 0 ? this.data.GalleryMobileHeight : 500
      },
    },
    methods: {
      handleOpenImage (image) {
        if (!this.isSimulation) {
          this.overlay = image !== null ? true : false
          this.selectImage = image
        }
      }
    }
  }
</script>
